import { api, config } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';

const changesLog = '/changes_log/?log_type=for_user';
const changesLogSeen = (id) => `/changes_log/seen?change_log_id=${id}`;

export async function getLastChangeLog() {
  return await api.get(generatePath(changesLog), config('json'));
}

export async function seenLastChangeLog(id) {
  return await api.post(changesLogSeen(id), {}, config('json'));
}
